import AbstractModel, { Model } from './abstract-model';

@Model('ComSystProjectFrance')
export default class ComSystProjectFrance extends AbstractModel {
    public epsg: string;
    public systemeProjection: string;
    public codeSystProjection: number;
}